document.addEventListener("DOMContentLoaded", function () {

  function bindSearchClose(searchContainer) {
    const closeBtn = searchContainer.querySelector(".main-search__close");
    if (!closeBtn || searchContainer.dataset.bound) return;
    searchContainer.dataset.bound = "true";

    // 🔹 Close when hovering over specific nav items (with children & megamenu)
    const header = document.querySelector("#pageheader");
    header.addEventListener("mouseenter", (e) => {
      if (
        e.target.closest(
          ".navigation__item.navigation__item--with-children.navigation__item--with-mega-menu"
        )
      ) {
        closeBtn.click();
      }
    }, true); // use capture phase so it triggers early

    // 🔹 Also close when the mega menu actually opens (class added dynamically)
    const observer = new MutationObserver(() => {
      if (header.querySelector(".navigation__item--show-children")) {
        closeBtn.click();
      }
    });
    observer.observe(header, { childList: true, subtree: true });
  }

  // 🔹 Watch for search container appearing dynamically
  const containerObserver = new MutationObserver(() => {
    const searchContainer = document.querySelector(".header-search-content.wide-container:not(.hidden)");
    if (searchContainer) bindSearchClose(searchContainer);
  });

  containerObserver.observe(document.body, { childList: true, subtree: true });
});
